import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@lupita.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img
          src="https://images.unsplash.com/photo-1600948836101-f9ffda59d250"
          alt="Salón Lupita"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute bottom-12 left-12 text-white">
          <p className="overline text-primary">Panel administrador</p>
          <h2 className="font-serif-display text-4xl font-light">Estética Lupita</h2>
        </div>
      </div>

      <div className="relative flex items-center justify-center bg-background px-6">
        <div className="absolute right-5 top-5">
          <ThemeToggle />
        </div>
        <motion.form
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          onSubmit={submit}
          className="w-full max-w-sm"
          data-testid="login-form"
        >
          <Link to="/" className="font-serif-display text-2xl font-semibold">
            Lupita <span className="overline text-primary">Estética</span>
          </Link>
          <h1 className="mt-8 font-serif-display text-3xl">Bienvenida de nuevo</h1>
          <p className="mb-8 text-sm text-muted-foreground">Ingresa para administrar tu salón.</p>

          <div className="space-y-4">
            <div>
              <Label>Correo</Label>
              <Input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <Label>Contraseña</Label>
              <Input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          {error && (
            <p data-testid="login-error" className="mt-4 text-sm text-destructive">
              {error}
            </p>
          )}

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="mt-8 flex w-full items-center justify-center gap-2 bg-primary py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-gold-dark disabled:opacity-50"
          >
            <Lock size={15} strokeWidth={1.5} /> {loading ? "Ingresando..." : "Iniciar sesión"}
          </button>
          <p className="mt-6 text-center text-xs text-muted-foreground">
            Demo: admin@lupita.com / lupita123
          </p>
        </motion.form>
      </div>
    </div>
  );
}
